import React, {FC} from "react"
import * as PropTypes from "prop-types"

import History from "@irati/utils/history"
import {StepNames} from "../../../enums"
import {DistributeRewardImportType, DistributeRewardRecipient} from "../../../enums/DistributeRewardTypes"
import {DistributeRewardActions, DistributeRewardActionTypes, DistributeRewardState} from "../../../stores/DistributeReward/actions"
import DistributeRewardSummaryStep1 from "./DistributeRewardSummaryStep1"
import DistributeRewardSummaryStep2 from "./DistributeRewardSummaryStep2"

interface Props {
  onSubmit: () => void,
  dispatch: (action: DistributeRewardActionTypes) => void,
  payload: DistributeRewardState,
  setAllocationJourneyError: (isError: boolean) => void
}

const DistributeRewardSummary: FC<Props> = ({onSubmit, payload, dispatch, setAllocationJourneyError}, context) => {

  const handlePrevStep = () => {
    if (location.pathname.includes(StepNames.Confirm)) {
      History.push(`/flexi-assign/${StepNames.Message}`, context)
    } else {
      if(payload.rewardImportType === DistributeRewardImportType.IMPORT_CSV) {
        dispatch({
          type: DistributeRewardActions.UPDATE_RECIPIENTS,
          payload: {
            recipientsList: []
          }
        })
      }
      History.push(`/flexi-assign/${StepNames.Recipients}`, context)
    }
  }

  const buttonText =
    payload.recipientType === DistributeRewardRecipient.MANAGER ? "wallet.reward.admin.btn.assign" : "wallet.reward.admin.btn.sendReward"
  const isConfirmStep = location.pathname.includes(StepNames.Confirm)

  return isConfirmStep ? (
    <DistributeRewardSummaryStep2 onSubmit={onSubmit} payload={payload} handlePrevStep={handlePrevStep} buttonText={buttonText} />
  ) : (
    <DistributeRewardSummaryStep1
      payload={payload}
      dispatch={dispatch}
      handlePrevStep={handlePrevStep}
      setAllocationJourneyError={setAllocationJourneyError} />
  )
}

DistributeRewardSummary.contextTypes = {
  appPath: PropTypes.string.isRequired
}

export default DistributeRewardSummary
